/* eslint-disable no-unused-vars */
import { Box, Button, Link, TextField, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import account from '../services/account-service';
import { storageHandler } from '../utils/storage_handler';

const PREFIX = 'LoginPage';
const classes = {
  root: `${PREFIX}-root`,
  form: `${PREFIX}-form`
};
const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#0F1117'
  },
  [`& .${classes.form}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  }
}));

export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = async () => {
    const response = await account.login({ username, password });
    console.log(response);
    if (response.success) {
      storageHandler.localStorageSet('token', response.result.access_token);
      storageHandler.localStorageSet('usertype', response.result.usertype);
      storageHandler.localStorageSet('refresh_token', response.result.refresh_token);
      navigate('/');
    } else {
      alert('Login failed:  Incorrect username or password');
      console.error('Login error:', response.message);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleLogin();
    }
  };

  return (
    <Root className={classes.root}>
      <Box
        component="form"
        className={classes.form}
        noValidate
        autoComplete="off"
      >
        <TextField
          id="username"
          label="Username"
          variant="outlined"
          margin="normal"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          onKeyPress={handleKeyPress}
        />
        <TextField
          id="password"
          label="Password"
          type="password"
          variant="outlined"
          margin="normal"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyPress={handleKeyPress}
        />
        <Button variant="contained" color="primary" onClick={handleLogin}>
          Login
        </Button>
        <Typography variant="body2" sx={{ mt: 1 }}>
          <Link
            component="button"
            variant="body2"
            onClick={() => navigate('/forgot-password')}
            sx={{ cursor: 'pointer' }}
          >
            Forgot password?
          </Link>
        </Typography>
      </Box>
    </Root>
  );
}
